import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
// import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
//import './revgen.scss';
import { selectCurrentEmpid } from '../../pages/login/authSlice';
import { useGetDirectReporteesQuery } from '../../features/coaching/coachingHistoryGrid/coachingHistoryGridSlice';
import { useCreateCoachingToDoMutation } from './CoachingToDoSlice';

interface CascadeToDoProps {
    visible: boolean;
    todoDeatails: any;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setIsSaveSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CascadeToDo = (props: CascadeToDoProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [directReportee, setDirectReportee] = useState<any>([]);
    const [createToDo] = useCreateCoachingToDoMutation();
    const [selectedEmployees, setSelectedEmployees] = useState<any>([{ 'check': true, 'employee_number': props.todoDeatails.employeeNumber, 'name': props.todoDeatails.employeeName }]);

    const { data: directReporteeData } = useGetDirectReporteesQuery(
        { employeeNo: parseInt(loggedEmpNum, 10), includeHierarchy: true },
        { skip: !loggedEmpNum }
    );
    useEffect(() => {
        let data = [];
        const recipient = { 'check': true, 'employee_number': props.todoDeatails.employeeNumber, 'name': props.todoDeatails.employeeName };
        if (directReporteeData?.data?.length > 0) {
            data = directReporteeData?.data?.map((item: any) => {
                return {
                    ...item,
                    name: item.employee_name,
                };
            });
            const todoRecipient = data.findIndex((ele: any) => ele.employee_number?.toString() === props.todoDeatails?.employeeNumber);
            if (todoRecipient !== -1) {
                data.splice(todoRecipient, 1);
            }
            data.unshift(recipient);
            setDirectReportee(data);
        } else {
            data.unshift(recipient);
            setDirectReportee(data);
        }
    }, [directReporteeData]);
    useEffect(() => {
        if (selectedEmployees?.length <= 0) {
            const data = [{ 'check': true, 'employee_number': props.todoDeatails.employeeNumber, 'name': props.todoDeatails.employeeName }];
            setSelectedEmployees(data);
        }
    }, [selectedEmployees]);

    const handleSave = () => {
        let cascadeResponse = '';
        const todoData = {
            employeeNumbers: [props.todoDeatails?.employeeNumber],
            createBy: props.todoDeatails.createBy,
            coachingEntityTypeId: props.todoDeatails.coachingEntityTypeId,
            coachingEntityId: props.todoDeatails.coachingEntityId,
            title: props.todoDeatails.title,
            description: props.todoDeatails.description,
            startDate: props.todoDeatails.startDate,
            dueDate: props.todoDeatails.dueDate,
            coachingStatusId: props.todoDeatails.coachingStatusId,
        };
        createToDo(todoData)
            .unwrap()
            .then((res: any) => {
                if (res.data && selectedEmployees.length <= 1) {
                    props.setIsSaveSuccess(true);
                    if (res.data === 'Successfully inserted') {
                        toast.success('ToDo cascaded successfully.');
                    }
                    else {
                        toast.error('There is another active ToDo with the same title. Please provide a distinct title for the ToDo.');
                    }
                }
                else {
                    cascadeResponse = res.data;
                }
            })
            .catch(() => {
                toast.error('ToDo creation failed.');
            });
        if (selectedEmployees.length > 1) {
            const recipients: any = [];
            selectedEmployees.forEach((element: any) => {
                if (element?.employee_number?.toString() !== props.todoDeatails?.employeeNumber)
                    recipients.push(element?.employee_number?.toString());
            });
            const todoData1 = {
                employeeNumbers: recipients,
                createBy: props.todoDeatails.createBy,
                coachingEntityTypeId: props.todoDeatails.coachingEntityTypeId,
                title: props.todoDeatails.title,
                description: props.todoDeatails.description,
                startDate: props.todoDeatails.startDate,
                dueDate: props.todoDeatails.dueDate,
                coachingStatusId: props.todoDeatails.coachingStatusId,
            };
            createToDo(todoData1)
                .unwrap()
                .then((res: any) => {
                    if (res.data) {
                        props.setIsSaveSuccess(true);
                        if (res.data === 'Successfully inserted' && cascadeResponse === 'Successfully inserted') {
                            toast.success('ToDo cascaded successfully.');
                        }
                        else {
                            const employeesArray = [];
                            if(res.data !== 'Successfully inserted') {
                             employeesArray.push(...res.data.split('; '));
                            }
                            if (cascadeResponse !== 'Successfully inserted') {
                                employeesArray.push(cascadeResponse);
                            }
                            if (recipients.length + 1 === employeesArray.length) {
                                toast.error("The ToDo was not cascaded because another active ToDo with the same title already exists for these employees.")
                            }
                            else {
                                toast.warning(`The ToDo was cascaded successfully, but was not cascaded to the following employee(s): ${employeesArray.join(', ')} because they already have an active ToDo with the same title.`);
                            }
                        }
                    }
                })
                .catch(() => {
                    toast.error('ToDo creation failed.');
                });
        }
        props.setVisible(false);
    };
    const onAllRowsUnselect = () => {
        const data = [{ 'check': true, 'employee_number': props.todoDeatails.employeeNumber, 'name': props.todoDeatails.employeeName }];
        setSelectedEmployees(data);
    };
    const handleSelectedEmployees = (e: any) => {
        const selectedList = e.value.filter((emp: any) => emp.employee_number !== props.todoDeatails.employeeNumber);
        const mandatoryEmployee = {
            'check': true,
            'employee_number': props.todoDeatails.employeeNumber,
            'name': props.todoDeatails.employeeName
        };
        const updatedEmployees = [mandatoryEmployee, ...selectedList];
        setSelectedEmployees(updatedEmployees);
    };
    return (
        <Dialog
            header={`Cascading ToDo`}
            visible={props.visible}
            style={{ width: '50vw' }}
            onHide={() => props.setVisible(false)}
        >
            <DataTable
                value={directReportee}
                selectionMode="checkbox"
                rows={5}
                scrollable
                scrollHeight="250px"
                style={{ minWidth: '10rem', marginTop: '10px' }}
                rowsPerPageOptions={[5, 10, 25, 50]}
                paginator={directReportee?.length > 5}
                selection={selectedEmployees}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                dataKey="employee_number"
                onSelectionChange={handleSelectedEmployees}
                onAllRowsUnselect={onAllRowsUnselect}
            >
                <Column selectionMode="multiple" style={{ minWidth: '6rem' }} />
                <Column header="Select All" field={'name'} />
            </DataTable>
            <div className="float-end m-t-20">
                <div
                    className="col-md-4"
                    style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}
                >
                    <Button
                        label="Cancel"
                        // style={{ fontWeight: 400 }}
                        className="btn-secondary w-auto me-2"
                        onClick={() => {
                            props.setVisible(false);
                        }}
                    />
                    <Button label="Apply" disabled={selectedEmployees.length === 0} onClick={handleSave} className="btn-primary w-auto" />
                </div>
            </div>
        </Dialog>
    );
};
